import React from 'react';
import PropTypes from 'prop-types';
import { Grow, Snackbar } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faExclamationCircle,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import styled from 'styled-components';

const StyledSnackbar = styled(Snackbar)`
  .toast-notification {
    align-items: center;
    display: grid;
    grid-template-columns: 1fr auto;
    grid-column-gap: 1rem;
    justify-content: space-between;
    border-radius: 0;
    border: 1px solid;
    padding: 0.75rem 1.25rem;
    font-size: 1.125rem;
    line-height: 1.5;
    min-width: 500px;
    margin-top: 16px;
    &.success {
      background-color: #cde9da;
      border-color: #b9e1cb;
      color: #034c25;
    }
    &.alert {
      background-color: #f2d2d5;
      border-color: #edc0c4;
      color: #631017;
    }
    &.warning {
      background-color: #fff4da;
      border-color: #ffefcb;
      color: #856724;
    }
    &.info {
      background-color: #cce2eb;
      border-color: #b8d6e3;
      color: #003851;
    }
    .message-wrapper {
      align-items: center;
      display: grid;
      grid-template-columns: auto 1fr;
      grid-column-gap: 1rem;
    }
    svg {
      margin-right: 8px;
    }
  }
`;

export const ToastNotification = ({ open, variant, message, onClose }) => (
  <StyledSnackbar
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    open={open}
    TransitionComponent={Grow}
  >
    <div className={classNames('toast-notification', variant)}>
      <span className="message-wrapper">
        {variant === 'success' && (
          <span>
            <FontAwesomeIcon icon={faCheckCircle} />
          </span>
        )}
        {variant === 'alert' && (
          <span>
            <FontAwesomeIcon icon={faExclamationCircle} />
          </span>
        )}
        {message || ''}
      </span>
      <span
        onClick={onClose}
        style={{ marginLeft: '8px' }}
        className="fa-icon-close-button-wrapper"
      >
        <FontAwesomeIcon icon={faTimes} />
      </span>
    </div>
  </StyledSnackbar>
);
ToastNotification.propTypes = {
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  variant: PropTypes.string,
};
ToastNotification.defaultProps = {
  variant: 'success',
};
